(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/game-handler/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/components/ticketgames/game-handler/assets/javascripts/helpers.js');

let getOptimalWidth;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  getOptimalWidth = trinidad.components.require('utils', 'get-optimal-width').api;
} else {
  getOptimalWidth = svs.utils.getOptimalWidth;
}

const constants = {
  leia: {
    gameConfig: {
      VEIKKAUS: {
        minimumHeight: 320
      },
      default: {
        minimumHeight: 320
      }
    },
    gameEngineCode: {
      VEIKKAUS: 'EIN',
      FDJ: 'ITG'
    },
    lotteryChannel: {
      WEB: 'WEB',
      VOUCHER: 'VOUCHER'
    },
    PROVIDER: 'LEIA',
    currencyFormatter: (val) => val / 100,
    statusFormatter: (status) => {
      switch (status.toLowerCase()) {
        case 'open':
          return 'OPEN';
        case 'suspended':
          return 'SUSPENDED';
        default:
          return 'CLOSED';
      }
    }
  }
};

const mapLeiaGames = (leiaGame) => {
  const { PROVIDER, currencyFormatter, statusFormatter } = constants.leia;
  const { code, name, stakes, state, lotteryGameConfiguration, game, category } = leiaGame;
  const { theme } = lotteryGameConfiguration;
  const status = statusFormatter(state);
  return {
    gameEngineCode: game?.engine?.code,
    name,
    price: stakes && stakes[0]?.value && currencyFormatter(stakes[0].value),
    type: code,
    theme: theme.id,
    provider: PROVIDER,
    status,
    open: status === 'OPEN',
    category
  };
};

const mapAllGames = (games = [], ticketsConfig = [], voucherConfigs = [], cdn2 = null) => ticketsConfig?.map((config) => {
  const { leiaType } = config;
  const type = leiaType;

  let foundGame = games.find((game) => game.type === type);
  if (!foundGame) {
    foundGame = { open: false };
  }

  const foundVoucher = voucherConfigs?.find((voucher) => voucher.onlineTicketType.includes(type));
  const { voucherConfigId, active, onlineTicketType } = foundVoucher ?? {};
  foundGame.voucherId = voucherConfigId || null;
  foundGame.isGiftable = Boolean(active);
  foundGame.claimableAs = onlineTicketType?.split(',') || [];

  const { skinImages, themes, height, width, margin } = config;
  const theme = themes.find((theme) => theme.themeName.toLowerCase() === foundGame.theme?.toLowerCase());

  const createImageV2 = (image) => {
    const optimalWidth = image.availableWidths && getOptimalWidth ? getOptimalWidth(image.availableWidths, image.width) : 640;

    return {
      ...image,
      legacy: true,
      noscriptUrl: image.url.replace('{width}', optimalWidth),
      availableFormats: [
        {
          mimetype: 'image/webp',
          extension: 'webp'
        },
        {
          mimetype: 'image/png',
          extension: 'png'
        }
      ],
      fitWrapper: false,
      loadingLazy: false,
      sizes: '(min-width: 640px) 640px, 100vw',
      aspectRatio: {
        height: image.height,
        width: image.width
      },
      altText: image.altText || '',
      title: image.title || ''
    };
  };

  const mapSkins = ({ image, description }) => ({
    image: createImageV2(image),
    url: cdn2 + image.url.replace('{width}', Math.max(...(image.availableWidths || [image.width]))),
    description
  });
  const parsedThemes = themes?.map(({ skins, themeName }) => ({ themeName, skins: skins?.map(mapSkins) }));
  const skins = (theme?.skins ?? skinImages).map(mapSkins);
  const variations = skins.length;

  const normalizeSkinId = (skinId) => (skinId > 0 && skinId <= variations ? skinId : 1);
  config = { ...config, themes: parsedThemes };
  return {
    type,
    ...foundGame,
    variations,
    ...config,
    isLeia: Boolean(leiaType),
    ...theme,
    skins,
    normalizeSkinId,
    height: parseInt(height, 10),
    width: parseInt(width, 10),
    margin: parseInt(margin, 10)
  };
}) ?? [];

const log = (msg, type = 'debug') => {
  const logger = svs.core.log.getLogger('components:game-handler');
  logger[type](msg);
};

const validPackageGameSkinId = (packageGameSkinId = null) => {
  if (packageGameSkinId) {
    const valid = !isNaN(packageGameSkinId);
    !valid && svs.ticketgames.gameHandler.helpers.log(`invalid packageGameSkinId ${packageGameSkinId}`, 'warn');
    return valid;
  }
  return true;
};

const getApplicableGamesByVoucher = (games, voucher) => {
  return games
    .filter((game) => Number(game.voucherId) === Number(voucher.voucherConfigId) && game.open)
    .sort((a, b) => (a.claimableAs.indexOf(a.type) + 1 || Infinity) - (b.claimableAs.indexOf(b.type) + 1 || Infinity));
};

const getPackageGameConfig = ({ packageGameThemeName = null, packageGameType, packageGameSkinId = null, packageGameAvailableThemes = [] } = {}, allGames) => {
  let skinId = 1,
    theme, skinUrl, gameToReturn;
  allGames.forEach((game) => {
    const { type, open, themeName, themes } = game;
    if (type === packageGameType && open) {
      const themeExistInGameConfig = Boolean(packageGameAvailableThemes?.find((themeName) => themeName === packageGameThemeName));
      theme = themes.find((t) => t.themeName === themeName); 
      skinUrl = theme.skins[skinId - 1].url; 
      if (themeExistInGameConfig && validPackageGameSkinId(packageGameSkinId)) {
        const cmsTheme = game.themes?.find(({ themeName }) => themeName === packageGameThemeName);
        if (cmsTheme) {
          skinId = parseInt(packageGameSkinId, 10) % cmsTheme?.skins?.length;
          theme = cmsTheme;
          skinUrl = theme.skins[skinId - 1].url;
        }
      }
      gameToReturn = {
        ...game,
        packageGameConfig: {
          theme,
          skinId,
          skinUrl,
          type
        }
      };
      svs.ticketgames.gameHandler.helpers.log(`packageGameType ${type} used with theme ${theme.themeName} and skinId ${skinId}`, 'debug');
    }
  });

  const hasPackageGameConfigured = Boolean(gameToReturn);
  if (!hasPackageGameConfigured) {
    const triss30 = { voucherConfigId: 3 };
    const defaultTicket = getApplicableGamesByVoucher(allGames, triss30)[0];
    allGames.forEach((game) => {
      const { type, themeName, themes } = game;
      if (defaultTicket?.type === type) {
        const theme = themes.find((t) => t.themeName === themeName);
        const skinUrl = theme.skins[skinId - 1].url;
        gameToReturn = {
          ...game,
          packageGameConfig: {
            type,
            theme,
            skinUrl,
            skinId
          }
        };
        svs.ticketgames.gameHandler.helpers.log(`packageGameType is not configured - using applicable voucher game`, 'warn');
      }
    });
  }

  if (!gameToReturn && !svs.core.config.data.svsconfig.isSelfService) {
    svs.ticketgames.gameHandler.helpers.log(`packageGameType is not set`, 'error');
  }

  return gameToReturn;
};

if (svs.isServer) {
  module.exports = {
    mapLeiaGames,
    mapAllGames
  };
} else {
  setGlobal('svs.ticketgames.gameHandler.constants', constants);
  setGlobal('svs.ticketgames.gameHandler.helpers', {
    mapLeiaGames,
    mapAllGames,
    getPackageGameConfig,
    log
  });
}


 })(window);